<div class="revenue-card-skeleton">
  <div class="card-content">
    <div class="skeleton-title"></div>

    <div class="amount-section">
      <div class="skeleton-amount"></div>
      <div class="skeleton-percentage"></div>
    </div>

    <div class="metrics-section">
      <div class="metric">
        <div class="skeleton-metric-line"></div>
      </div>
      <div class="metric">
        <div class="skeleton-metric-line"></div>
      </div>
    </div>
  </div>
</div>
